import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { PATHS } from "@/constants";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-muted-foreground font-mono text-sm">404</p>
      <h1 className="mt-2 text-xl font-semibold">{t("notFound.title")}</h1>
      <p className="text-muted-foreground mt-2 max-w-sm text-sm">{t("notFound.body")}</p>
      <Button asChild className="mt-6">
        <Link to={PATHS.DASHBOARD}>{t("notFound.cta")}</Link>
      </Button>
    </div>
  );
}
